export default __webpack_public_path__ + "static/media/root-chakra.73fa27a8.png";